/**
 * Entry point of the jö sso round-trip as seen from the browser.
 *
 * The provider is not entered directly: the customer goes through `/mein-konto/joe-connect`, which
 * remembers where they started before forwarding them. Without that hop the fixed callback url jö
 * returns to has no way of knowing whether the flow began on the My Account overview or in the
 * checkout.
 *
 * The parameter names are the contract the legacy checkout fragment already speaks, so both entry
 * points share one pair of endpoints.
 */

/** Query parameter names of the connect hop. Read back by the api route serving it. */
export const JOE_RETURN_TO_PARAM = 'returnTo';
export const JOE_DESTINATION_PARAM = 'dest';

export type JoeConnectUrlArgs = {
  /** Path of the connect hop, from `order.paths.myAccountJoeConnect`. */
  connectPath: string;
  /** The jö sso url resolved for this customer. */
  loginUrl: string;
  /** Where the callback should return to - a path on this origin. */
  returnTo: string;
};

export const buildJoeConnectUrl = ({ connectPath, loginUrl, returnTo }: JoeConnectUrlArgs) => {
  const params = new URLSearchParams({
    [JOE_RETURN_TO_PARAM]: returnTo,
    [JOE_DESTINATION_PARAM]: loginUrl,
  });

  return `${connectPath}?${params.toString()}`;
};
